<div class="left-card-content" (transitionend)="transitionEndHandler($event)" #cardContentContainer>
  <ng-container *ngIf="!isHidden">
    <div class="left-card-content-header left-card-content-block d-block" *ngIf="headerRef">
      <ng-container [ngTemplateOutlet]="headerRef"></ng-container>
    </div>

    <ng-container *ngIf="scrollbarEnabled; else noScrollingBody">
      <div class="left-card-content-body left-card-content-block d-flex flex-column">
        <div
          shrdUicScrollbar
          [scrollContentRef]="scrollContent"
          [initialScrollTo]="scrollToTargetSelector"
          [scrollBarVerticalRef]="verticalScrollbar"
          class="h-100"
        >
          <div #scrollContent class="d-flex flex-column min-h-100">
            <ng-container [ngTemplateOutlet]="bodyRef"></ng-container>
          </div>
        </div>
        <shrd-uic-scrollbar #verticalScrollbar></shrd-uic-scrollbar>
      </div>
    </ng-container>
    <ng-template #noScrollingBody>
      <div class="left-card-content-body left-card-content-block d-flex">
        <div class="flex-grow-1">
          <ng-container [ngTemplateOutlet]="bodyRef"></ng-container>
        </div>
      </div>
    </ng-template>

    <div class="left-card-content-footer left-card-content-block" *ngIf="footerRef">
      <ng-container [ngTemplateOutlet]="footerRef"></ng-container>
    </div>
  </ng-container>
</div>
